'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _axiosRetry = require('axios-retry');

var _axiosRetry2 = _interopRequireDefault(_axiosRetry);

var _semanticUiReact = require('semantic-ui-react');

var _followersBarChart = require('../followers-bar-chart');

var _followersBarChart2 = _interopRequireDefault(_followersBarChart);

var _formatting = require('./../../utils/formatting');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var iconStyle = {
  'vertical-align': 'middle',
  display: 'inline',
  height: 35
};

var loadingStyle = {
  minHeight: 90,
  marginTop: 30
};

var textCenterStyle = {
  textAlign: 'center',
  width: '100%'
};

var TiktokProfileDataLarge = function (_React$Component) {
  (0, _inherits3.default)(TiktokProfileDataLarge, _React$Component);

  function TiktokProfileDataLarge() {
    (0, _classCallCheck3.default)(this, TiktokProfileDataLarge);

    var _this = (0, _possibleConstructorReturn3.default)(this, (TiktokProfileDataLarge.__proto__ || (0, _getPrototypeOf2.default)(TiktokProfileDataLarge)).call(this));

    _this.state = {
      loading: false,
      profile: {}
    };
    _this.restClient = _axios2.default.create({
      baseURL: process.env.REACT_APP_GET_TWITTER_URL,
      timeout: 5000
    });

    (0, _axiosRetry2.default)(_this.restClient, {
      delay: 100,
      retries: 3
    });
    return _this;
  }

  (0, _createClass3.default)(TiktokProfileDataLarge, [{
    key: 'componentWillMount',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log('data mount');

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentWillMount() {
        return _ref.apply(this, arguments);
      }

      return componentWillMount;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          influencer = _props.influencer,
          countHistory = _props.countHistory;
      var _state = this.state,
          profile = _state.profile,
          loading = _state.loading;
      var tiktokProfileData = influencer.tiktokProfileData,
          tiktokThumbnail = influencer.tiktokThumbnail;

      var _ref2 = tiktokProfileData || {},
          engagementData = _ref2.engagementData,
          verified = _ref2.verified,
          handle = _ref2.username;

      var _ref3 = engagementData || {},
          postsPerWeek = _ref3.postsPerWeek,
          likes = _ref3.likes,
          comments = _ref3.comments,
          shares = _ref3.shares,
          engagementRate = _ref3.engagementRate;

      console.log('tiktok profile', profile);

      var tiktokData = _lodash2.default.filter(countHistory, function (item) {
        return _lodash2.default.has(item, 'tiktokCount');
      });
      if (_lodash2.default.isEmpty(tiktokData)) {
        tiktokData = [{
          tiktokCount: _lodash2.default.get(influencer, 'tiktokCount'),
          createdDate: (0, _moment2.default)().format('MMM D')
        }];
      }
      console.log('tiktokData', tiktokData);
      var graphProps = {
        label: 'followers',
        labels: _lodash2.default.map(tiktokData, function (item) {
          return (0, _moment2.default)(item.createdDate).format('MMM D');
        }),
        values: _lodash2.default.map(tiktokData, 'tiktokCount'),
        rgbColorCode: '#000'
      };
      var lastTiktokScan = _lodash2.default.last(tiktokData);
      return _react2.default.createElement(
        _semanticUiReact.Segment,
        { color: 'black' },
        loading && _react2.default.createElement(_semanticUiReact.Loader, {
          active: true,
          inline: 'centered',
          content: 'Loading Tiktok data',
          style: loadingStyle
        }),
        !loading && _react2.default.createElement(
          _semanticUiReact.Grid,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 16 },
              _react2.default.createElement(
                'h3',
                null,
                _react2.default.createElement(_semanticUiReact.Image, { src: 'https://app.dyzio.co/icons/tiktok.svg', alt: 'Tiktok', style: iconStyle }),
                'Tiktok'
              ),
              _react2.default.createElement(_semanticUiReact.Divider, null)
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { divided: true },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 4 },
              _react2.default.createElement(_semanticUiReact.Image, {
                src: tiktokThumbnail,
                shape: 'circular',
                centered: true,
                size: 'small'
              }),
              _react2.default.createElement(
                _semanticUiReact.Table,
                { basic: 'very', fluid: true, textAlign: 'center' },
                _react2.default.createElement(
                  _semanticUiReact.Table.Body,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Table.Row,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Table.Cell,
                      null,
                      handle,
                      verified && _react2.default.createElement(_semanticUiReact.Icon, { name: 'check circle', color: 'blue' })
                    )
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Table.Row,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Table.Cell,
                      null,
                      (0, _formatting.commaFormatted)(lastTiktokScan.tiktokCount),
                      ' followers'
                    )
                  ),
                  !verified && _react2.default.createElement(
                    _semanticUiReact.Table.Row,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Table.Cell,
                      null,
                      _react2.default.createElement(_semanticUiReact.Popup, {
                        trigger: _react2.default.createElement(_semanticUiReact.Label, { basic: true, color: 'grey', content: 'not verified' }),
                        content: handle + ' is not verified by Tiktok (blue tick)'
                      })
                    )
                  )
                )
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 7 },
              _react2.default.createElement(_followersBarChart2.default, (0, _extends3.default)({}, graphProps, {
                percentageRange: 0.5
              }))
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 5 },
              loading && _react2.default.createElement(_semanticUiReact.Loader, { active: true, content: 'Loading...' }),
              engagementRate && !loading && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  _semanticUiReact.Statistic,
                  { style: textCenterStyle },
                  _react2.default.createElement(
                    _semanticUiReact.Statistic.Value,
                    null,
                    (0, _formatting.ierFormat2DP)(engagementRate),
                    '%'
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Statistic.Label,
                    null,
                    'engagement rate'
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table,
                  { basic: 'very', fluid: true, compact: true },
                  _react2.default.createElement(
                    _semanticUiReact.Table.Body,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Table.Row,
                      null,
                      _react2.default.createElement(
                        _semanticUiReact.Table.Cell,
                        null,
                        'posts per week'
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Table.Cell,
                        null,
                        (0, _formatting.countFormat)(postsPerWeek)
                      )
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Table.Row,
                      null,
                      _react2.default.createElement(
                        _semanticUiReact.Table.Cell,
                        null,
                        'avg. likes per post'
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Table.Cell,
                        null,
                        (0, _formatting.countFormat)(likes)
                      )
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Table.Row,
                      null,
                      _react2.default.createElement(
                        _semanticUiReact.Table.Cell,
                        null,
                        'avg. comments per post'
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Table.Cell,
                        null,
                        (0, _formatting.countFormat)(comments)
                      )
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Table.Row,
                      null,
                      _react2.default.createElement(
                        _semanticUiReact.Table.Cell,
                        null,
                        'avg. shares per post'
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Table.Cell,
                        null,
                        (0, _formatting.countFormat)(shares)
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return TiktokProfileDataLarge;
}(_react2.default.Component);

TiktokProfileDataLarge.propTypes = {
  influencer: _propTypes2.default.object.isRequired,
  countHistory: _propTypes2.default.array
};

TiktokProfileDataLarge.defaultProps = {
  countHistory: []
};

exports.default = TiktokProfileDataLarge;


/*****************
 ** WEBPACK FOOTER
 ** ./~/dyzio-shared-components/lib/components/tiktok-profile-data-large/index.js
 ** module id = 2569
 ** module chunks = 0
 **/